const strings = {
  description: 'Auditando dados do agricultor',
  userRegister: {
    title: 'Quem Cadastrou?',
    description: 'Verifique abaixo quem cadastrou os resultados do agricultor',
  },
}

export default strings
